export default __webpack_public_path__ + "static/media/kitchen4-afterA-1024w.8d17cc55.webp";